import { Injectable, signal } from '@angular/core';
import { FeatureFlags } from './features.enum';

@Injectable({ providedIn: 'root' })
export class AppFeatureFlagsService {
  private features = signal<Set<FeatureFlags> | null>(null);
  featuresFlags = this.features.asReadonly();

  hasFeatures(features: FeatureFlags): boolean {
    return !!this.features()?.has(features);
  }

  setFeatures(features: Array<FeatureFlags>): void {
    this.features.set(new Set(features));
  }
}
